import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import React from 'react';

import { toSxArray } from '_lib/utils/helpers';

import { Accordion, AccordionProps } from '../Accordion/Accordion';
import { AccordionDetails } from '../AccordionDetail/AccordionDetail';
import { AccordionSummary } from '../AccordionSummary/AccordionSummary';
import { Typography } from '../Typography/Typography';

export type ErrorDetailsProps = Omit<AccordionProps, 'children'> & {
  errors: string[];
};

export const ErrorDetailsAccordion = (props: ErrorDetailsProps) => {
  const { errors, sx, ...accordionProps } = props;

  return (
    <Accordion
      disableGutters
      {...accordionProps}
      sx={[
        (theme) => ({
          backgroundColor: theme.palette.error.main,
          color: theme.palette.error.contrastText
        }),
        ...toSxArray(sx)
      ]}>
      <AccordionSummary>
        <ErrorOutlineIcon />
        <Typography text='Errors Present. Click to view Details' sx={{ paddingLeft: 1 }} />
      </AccordionSummary>
      <AccordionDetails>
        {errors.map((error, index) => (
          <Typography key={index} text={error} />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
